import { useEffect, useRef } from 'react';

const SCRIPT_ID = 'google-recaptcha-api';

const loadRecaptcha = () => new Promise((resolve, reject) => {
  if (window.grecaptcha?.render) {
    resolve(window.grecaptcha);
    return;
  }

  const existing = document.getElementById(SCRIPT_ID);
  if (existing) {
    existing.addEventListener('load', () => resolve(window.grecaptcha), { once: true });
    existing.addEventListener('error', reject, { once: true });
    return;
  }

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
  script.async = true;
  script.defer = true;
  script.onload = () => resolve(window.grecaptcha);
  script.onerror = reject;
  document.head.appendChild(script);
});

/** Google reCAPTCHA v2 widget. The API still verifies its token server-side. */
const Recaptcha = ({ onChange, onError, resetKey }) => {
  const element = useRef(null);
  const widgetId = useRef(null);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  useEffect(() => {
    if (!siteKey) {
      onError?.('La vérification anti-robot n’est pas configurée.');
      return undefined;
    }

    let active = true;
    loadRecaptcha()
      .then((grecaptcha) => {
        if (!active || !grecaptcha?.render || widgetId.current !== null) return;
        widgetId.current = grecaptcha.render(element.current, {
          sitekey: siteKey,
          callback: onChange,
          'expired-callback': () => onChange(''),
          'error-callback': () => onError?.('La vérification anti-robot est indisponible. Réessayez.'),
        });
      })
      .catch(() => onError?.('La vérification anti-robot est indisponible. Réessayez.'));

    return () => { active = false; };
  }, [siteKey, onChange, onError]);

  useEffect(() => {
    if (widgetId.current === null || !window.grecaptcha) return;
    window.grecaptcha.reset(widgetId.current);
  }, [resetKey]);

  return <div className="contact-recaptcha" ref={element} />;
};

export default Recaptcha;
